import type { InjectionKey } from 'vue'
import type { StepsType, StepData, LineType } from './types'
export interface StepsContext {
  stepsType: StepsType
  innerCurrent: number
  parentCls: string
  addItem(step: number, data: StepData): void
  removeItem(step: number): void
  onClick(step: number, ev: Event): void
  count: number
  lineType: LineType
}

export const stepsInjectionKey: InjectionKey<StepsContext> = Symbol('stepsKey')
